import { useEffect, useRef } from "react";
import { useCanEdit } from "./use-can-edit";

/**
 * Runs `onLost` when the viewer loses edit access mid-session (a member demoted to reviewer), so
 * write flows that were already open (dialogs, inline edits, drafts) close instead of offering a
 * submit the server will refuse. Never fires on first load.
 */
export function useOnEditAccessLost(onLost: () => void) {
  const canEdit = useCanEdit();
  const couldEditRef = useRef(canEdit);
  const onLostRef = useRef(onLost);
  onLostRef.current = onLost;

  useEffect(() => {
    if (couldEditRef.current && !canEdit) onLostRef.current();
    couldEditRef.current = canEdit;
  }, [canEdit]);
}
